import { LitElement, html, css } from 'lit';

class EmojiReactions extends LitElement {
  static properties = {
    isOpen: { type: Boolean },
    onEmojiSelect: { type: Function },
    selectedEmojis: { type: Array },
    currentPage: { type: Number },
  };

  static styles = css`
    .emoji-container {
      position: absolute;
      background: var(--bg-primary-color);
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      padding: 8px;
      display: flex;
      align-items: center;
      gap: 8px;
      z-index: 100;
      bottom: 100%;
      margin-bottom: 8px;
      width: max-content;
    }


    .emoji-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 8px;
    }

    .emoji-button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      border-radius: 4px;
      transition: background-color 0.2s;
      font-size: 24px; /* Increased emoji size */
    }

    .nav-button {
      background: var(--bg-secondary-color);
      border: none;
      cursor: pointer;
      padding: 4px;
      color: var(--text-primary-color);
      font-size: 20px;
      border-radius: 50%;
      display: flex;
    }

    .nav-button:hover {
      background: var(--bg-secondary-color);
      border-radius: 50%;
    }

    .emoji-button img {
      width: 24px;
      height: 24px;
    }

    .emoji-button:hover {
      background: var(--bg-secondary-color);
    }

    .selected-emojis {
      display: flex;
      gap: 4px;
      margin-top: 4px;
    }

    .emoji-count {
      background: var(--bg-secondary-color);
      padding: 2px 6px;
      border-radius: 12px;
      font-size: 12px;
    }

    .emoji-count img {
      width: 24px;
      height: 24px;
    }
  `;

  constructor() {
    super();
    this.isOpen = false;
    this.selectedEmojis = [];
    this.currentPage = 0;
    this.emojis = [
      { id: 'star', src: '⭐' },
      { id: 'crying_with_laughter', src: '😂' },
      { id: 'yes', src: '👍' },
      { id: 'no', src: '❌' },
      { id: 'party', src: '🥳' },
      { id: 'high_five', src: '✋' },
      { id: 'rock', src: '🪨' },
      { id: 'facepal', src: '🤦' },
      { id: 'sarcastic', src: '🙄' },
      { id: 'talking_too_much', src: '🤫' },
      { id: 'crying', src: '😭' },
      { id: 'heart', src: '❤️' },
      { id: 'surprised', src: '😮' },
      { id: 'bowing', src: '🙇' },
    ];
  }

  get visibleEmojis() {
    const start = this.currentPage * 5;
    return this.emojis.slice(start, start + 5);
  }

  nextPage() {
    if ((this.currentPage + 1) * 5 < this.emojis.length) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  render() {
    return html`
      ${this.isOpen
        ? html`
            <div class="emoji-container">
              ${this.currentPage > 0 ? html`<button class="nav-button" @click=${() => this.prevPage()}>
                 <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.3508 12.7499L11.2096 17.4615L10.1654 18.5383L3.42264 11.9999L10.1654 5.46148L11.2096 6.53833L6.3508 11.2499L21 11.2499L21 12.7499L6.3508 12.7499Z" fill="#080341"></path> </g></svg>
              </button>` : ''}
              <div class="emoji-grid">
                ${this.visibleEmojis.map(
                  emoji => html`
                    <button class="emoji-button" @click=${() => this.handleEmojiClick(emoji)}>
                      <span>${emoji.src}</span>
                    </button>
                  `,
                )}
              </div>
              ${(this.currentPage + 1) * 5 < this.emojis.length ? html`<button class="nav-button" @click=${() => this.nextPage()}>
               <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6492 11.2501L12.7904 6.53852L13.8346 5.46167L20.5774 12.0001L13.8346 18.5385L12.7904 17.4617L17.6492 12.7501H3V11.2501H17.6492Z" fill="#080341"></path> </g></svg>
              </button>` : ''}
            </div>
          `
        : ''}
      ${this.selectedEmojis.length > 0
        ? html`
            <div class="selected-emojis">
              ${this.selectedEmojis.map(
                ({ emoji, count }) => html`
                  <span class="emoji-count">
                    <span>${emoji.src}</span>
                  </span>
                `,
              )}
            </div>
          `
        : ''}
    `;
  }

  handleEmojiClick(emoji) {
    this.dispatchEvent(
      new CustomEvent('emoji-selected', {
        detail: { emojiId: emoji.id, emojiSrc: emoji.src },
        bubbles: true,
        composed: true,
      }),
    );
    this.onEmojiSelect(emoji);
  }
}

customElements.define('emoji-reactions', EmojiReactions);
